import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";

import { PlusArchiveTitle } from "scmp-app/components/plus/archive/archive-title";
import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";
import { usePlusDetailedListingPopup } from "scmp-app/components/plus/detailed-listing-popup/hooks";
import type { chinaFutureTechBriefingsPlusArchiveQuery$key } from "scmp-app/queries/__generated__/chinaFutureTechBriefingsPlusArchiveQuery.graphql";

import { Container, ContentItemContainer, StyledContentItemPlusPrimary } from "./styles";

type Props = {
  className?: string;
  reference: chinaFutureTechBriefingsPlusArchiveQuery$key;
};
export const PlusArchiveChinaFutureTechBriefings: FunctionComponent<Props> = ({
  className,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment chinaFutureTechBriefingsPlusArchiveQuery on Query
      @argumentDefinitions(chinaFutureTechBriefingsTypeUuid: { type: "String!" }) {
        plusArchiveChinaFutureTechBriefings: contents(
          articleFilterInput: { articleTypeIds: [$chinaFutureTechBriefingsTypeUuid] }
          first: 2

          orderBy: { field: PUBLISHED_DATE, direction: DESC }
        ) {
          edges {
            node {
              entityId
              ...plusPrimaryContentItemContent
              ...hooksPlusArticleLinkHandlerArticle
            }
          }
        }
      }
    `,
    reference,
  );

  const { handleOpen: handleOpenDetailedListingPopup } = usePlusDetailedListingPopup();
  const { handleOpen: handleOpenArticlePopup } = usePlusArticlePopup();

  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: "china_future_tech",
      }}
    >
      <Container className={className}>
        <PlusArchiveTitle
          onClick={() =>
            handleOpenDetailedListingPopup({
              pgtype: "archive",
              type: "china-future-tech-briefing",
            })
          }
          title="China Future Tech Briefings"
        />
        <ContentItemContainer>
          {content?.plusArchiveChinaFutureTechBriefings?.edges.map(edge => (
            <StyledContentItemPlusPrimary
              key={edge.node.entityId}
              onClick={() =>
                handleOpenArticlePopup(edge.node, {
                  pageType: "archive",
                  widgetName: "china_future_tech",
                })
              }
              reference={edge.node}
              withArticleType={false}
              withSummary={false}
            />
          ))}
        </ContentItemContainer>
      </Container>
    </BaseLinkContextProvider>
  );
};

PlusArchiveChinaFutureTechBriefings.displayName = "PlusArchiveChinaFutureTechBriefings";
